import { render, staticRenderFns } from "./newTable.vue?vue&type=template&id=23477ca1"
import script from "./newTable.vue?vue&type=script&lang=js"
export * from "./newTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports